// @ts-expect-error Typing unklar
const pending = [];

function next() {
  // @ts-expect-error Typing unklar
  const fn = pending.shift();
  if (fn) {
    fn(next);
  }
}

/**
 * (Internal) Queues up an action. Doesn't execute actions unless others have finished.
 *
 * @param {(() => any) => void} fn
 */
// @ts-expect-error Typing unklar
export function queue(fn) {
  pending.push(fn);
  if (pending.length === 1) {
    next();
  }
}
